import { NodeType } from '@/enums/node-type.enum';
import { isForcedMandatoryInputNode } from '@/queries/toolConfigModel';
import type { Edge } from '@/types/node';
import type { InputId, NodeId } from 'web';

/**
 * Whether Run must wait for this input to be filled: it is Mandatory or fed to a required handle, or
 * it is an iterator or a LoRA, which have nothing to run on without a value.
 */
export function blocksRunWhenEmpty(input: { type?: string; isIterator?: boolean; required?: boolean }): boolean {
  if (input.required) return true;
  if (input.type === NodeType.MediaIterator || input.type === NodeType.MultiLora) return true;
  return input.type === NodeType.MuxV2 && input.isIterator === true;
}

/**
 * Whether a tool input is required: marked so in its config, or forced by the graph because it feeds
 * a required handle. The config leaves the forced case unset, so it is derived here as core does.
 */
export function isToolInputRequired(
  nodeId: NodeId,
  configRequired: boolean | undefined,
  edges: Edge[],
  isInputRequired: (nodeId: NodeId, inputId: InputId) => boolean,
): boolean {
  return configRequired === true || isForcedMandatoryInputNode(nodeId, edges, isInputRequired);
}
